export class UssdPayload {
  imsi: string;
  mnoSessionId: string;
  msisdn: string;
  msg: string;
  network: string;
  sessionId: string;
  type: string;
  constructor(_imsi, _mnoSessionId, _msisdn, _msg, _network, _sessionId, _type) {
    this.msisdn = _msisdn;
    this.msg = _msg;
    this.network = _network;
    this.sessionId = _sessionId;
    this.type = _type;
    this.imsi = _imsi;
    this.mnoSessionId = _mnoSessionId;
  }
}
